
import Vue from "vue";
import { Watch } from "vue-property-decorator";
import ThemeUpdatingView from "../general/ThemeUpdatingView.vue";

export default abstract class CensorableChart extends ThemeUpdatingView {
  /**
   * 👂 Listener for changes in the flag for whether data should be censored
   */
  @Watch("$store.state.userPreferences.censorSensitiveData")
  private onFlagForCensoringDataChanged(val: boolean, oldVal: boolean) {
    this.createChart();
  }

  protected themeUpdate() {
    this.createChart();
  }

  /**
   * 🏗 Function which should be (re)creating the chart
   */
  protected abstract createChart(): void;
}
